import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import '../../../../assets/styles/finalReport/templateCard.css';
import DeleteTemplateDialog from './templateDialogs/deleteTemplateDialog';

import { FinalReportTemplate } from '../../../../interfaces/FinalReportTemplate';

import {
  BuilderFields,
  DynamicFieldWithSibling,
  FinalReportTemplateBuilder,
} from '~/pages/customer/settings/final-report/template-builder/route';

interface TemplateCardProps {
  title: string;
  index: number;
  template: FinalReportTemplate;
}

const TemplateCard = ({ title, index, template }: TemplateCardProps) => {
  const raisedShadowStyle =
    '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);';

  const isPopulated =
    template.case_manager_name ||
    template.date_received ||
    template.report_reference ||
    template.report_severity ||
    template.report_type;
  const fields: Array<DynamicFieldWithSibling> =
    template.final_report_custom_field.map((field) => {
      const items = field.dropdown_choices.map((choice) => ({
        value: choice,
      }));
      return {
        id: field.id,
        type: field.type,
        value: field.value || '',
        fieldTitle: field.label,
        placeholder: field.placeholder,
        isMandatory: field.is_mandatory,
        dropdownItems: items,
        siblings: [],
      };
    });

  const newTemplate: BuilderFields = {
    id: template.id,
    isPopulated: isPopulated,
    templateTitle: template.template_title,
    templateFields: fields,
    populatePermissions: {
      caseManager: template.case_manager_name,
      dateReceived: template.date_received,
      reportType: template.report_type,
      reportReference: template.report_reference,
      reportSeverity: template.report_severity,
    },
  };

  return (
    <Card
      sx={{
        width: '263px',
        '&:hover': {
          boxShadow: raisedShadowStyle,
          '& > .actions': {
            visibility: 'visible',
          },
        },
      }}
    >
      <CardContent
        sx={{
          height: '108px',
        }}
      >
        <Typography fontSize={14} color='#878787'>{`Template ${index + 1
          }`}</Typography>
        <Typography
          fontSize={20}
          marginTop='12px'
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: '2',
            WebkitBoxOrient: 'vertical',
          }}
        >
          {title}
        </Typography>
      </CardContent>
      <CardActions
        sx={{
          justifyContent: 'space-between',
          height: '60px',
        }}
        className='actions'
      >
        <DeleteTemplateDialog
          templateName={template.template_name}
          templateID={template.id}
        />
        <FinalReportTemplateBuilder defaultValues={newTemplate} />
      </CardActions>
    </Card>
  );
};

export default TemplateCard;
